import { useTranslation } from 'react-i18next'

import ImageViewIcon from '@/assets/image-view/image.svg'
import InstanceViewIcon from '@/assets/image-view/instance.svg'
import { ButtonRadio } from '@/components'

type CreationView = 'instance' | 'image'

export function CreationViewSwitch({
  value,
  onChange,
  withIcons = true,
}: {
  value: CreationView
  onChange: (value: CreationView) => void
  withIcons?: boolean
}) {
  const { t } = useTranslation()
  return (
    <ButtonRadio<CreationView>
      value={value}
      onChange={onChange}
      size={withIcons ? 'small' : undefined}
      className={withIcons ? 'gap-0 rounded-xl bg-neutral-50 p-1' : undefined}
      unselectedClassName="text-primary"
      rootProps={{ 'aria-label': 'Creation view' }}
      items={(['instance', 'image'] as const).map((view) => ({
        value: view,
        buttonProps: {
          'aria-pressed': value === view,
          className: withIcons
            ? 'w-32 px-3 py-2 text-xs font-bold leading-4 whitespace-nowrap'
            : undefined,
        },
        label: (
          <span className="flex items-center gap-1">
            {withIcons && (
              <span
                aria-hidden="true"
                className="h-5 w-5 shrink-0 bg-current"
                style={{
                  mask: `url(${view === 'instance' ? InstanceViewIcon : ImageViewIcon}) center / contain no-repeat`,
                  WebkitMask: `url(${view === 'instance' ? InstanceViewIcon : ImageViewIcon}) center / contain no-repeat`,
                }}
              />
            )}{' '}
            {t(`create.imageView.${view}View`)}
          </span>
        ),
      }))}
    />
  )
}
